import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getJobsSummary, GetJobsSummaryFilters } from "../services/job.services";

export const useGetJobsSummary = (filters?: GetJobsSummaryFilters) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.jobsSummary(filters),
    queryFn: () => getJobsSummary(filters),
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
